<template>
  <v-row class="lista-tiendas" dense>
    <v-col
      v-for="(tienda, i) in tiendas"
      :key="`tienda_${i}`"
      cols="12"
      sm="6"
      md="4"
    >
      <TiendaCard :tienda="tienda" />
    </v-col>
  </v-row>
</template>
<script>
import TiendaCard from '../components/cards/TiendaCard.vue'

export default {
  name: 'ListaTiendas',
  components: { TiendaCard },
  props: {
    tiendas: {
      type: Array
    }
  },
  mounted () {
    this.$vuetify.goTo(0)
  }
}
</script>

<style scoped>
.lista-tiendas {
  margin-top: 4px;
}
</style>
